import RequestAbstract from '../abstract';

export default class AccountingAgentTransactions extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/accounting-agent-transactions';
    }
}
